const testimonials = [
  {
    id: 1,
    name: "Martin Lorenz Dula",
    role: "Business Traveler",
    comment:
      "The Yamaha NMAX was impeccable! Smooth ride and excellent service with ample space. Will definitely rent again.",
    rating: 5,
    car: "Yamaha NMAX",
  },
  {
    id: 2,
    name: "Patricia Yvonne Albina",
    role: "Family Vacation",
    comment:
      "Perfect family Honda PCX 160 with ample space. Clean, well-maintained, and great value for money.",
    rating: 4,
    car: "Honda PCX 160",
  },
  {
    id: 3,
    name: "Serene Louisse Albina",
    role: "Road Trip Enthusiast",
    comment:
      "Honda Click 150i made our coastal ride unforgettable! 24/7 support was a lifesaver and value for money. .",
    rating: 5,
    car: "Honda Click 150i",
  },
];

export default testimonials;
